import {Checkbox} from "primereact/checkbox";
import {useEffect, useState} from "react";
import {ControlledInputText} from "@/components/molecules/form";
import {UseFormReturn} from "react-hook-form";


export function RegisterOptionOrganization({useForm, disabled}: {
  useForm: UseFormReturn<any, any, undefined>,
  disabled: boolean
}) {
  const [checked, setChecked] = useState<boolean>(false);

  useEffect(() => {
    if (!checked) {
      useForm.setValue('organization.siret', undefined)
    }
  }, [checked])

  return <div className="px-2 py-4">
    <Checkbox name={"is_organization"} checked={checked} disabled={disabled}
              onChange={e => setChecked(!!e.target.checked)}/>
    <span className="p-1">Je crée un compte pour une société, un association ou un organisme public</span>
    {checked && <div>
        <ControlledInputText disabled={disabled} useForm={useForm} required={false} label={"N° SIREN"}
                             name={"organization.siren"}/>
    </div>}
  </div>
}